import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface IGoogleScriptResponse {
  result: 'success' | 'error';
  data?: string;
  error?: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private readonly http = inject(HttpClient);

  // Google Apps Script expects multipart/form-data (not JSON) so the browser
  // doesn't send a CORS preflight, which Apps Script Web Apps don't handle.
  submitContactForm(formValue: Record<string, unknown>): Promise<IGoogleScriptResponse> {
    const formData = new FormData();
    Object.entries(formValue).forEach(([key, value]) => {
      formData.append(key, value == null ? '' : String(value));
    });

    return firstValueFrom(
      this.http.post<IGoogleScriptResponse>(environment.googleAppsScriptUrl, formData),
    );
  }
}
